import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Skeleton from 'react-loading-skeleton';

const PageLead = ({ children, size, className, loading }) => {
    const leadClasses = cx(
        'page__lead',
        {
            [className]: className,
        },
        {
            [`page__lead--${size}`]: size,
        },
    );

    return loading ? (
        <p className="text-center pt-1">
            <Skeleton height="60px" width="300px" />
        </p>
    ) : (
        <div className={leadClasses}>{children}</div>
    );
};

PageLead.propTypes = {
    children: PropTypes.any.isRequired,
    size: PropTypes.any,
    loading: PropTypes.bool,
};

export default PageLead;
